import { createApp } from 'vue'
import App from './App.vue'
// import 要大括号，否则会出import对象不是个函数报错
import {router} from './router/router'
import axios from 'axios'
import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';

const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.config.globalProperties.$axios=axios
app.mount('#app')
